import React from 'react';
import {
    SeverityLevel,
    SeverityLevelEnum
} from '../../../../shared/severity-level/SeverityLevel';

function RiskLevel(props) {
    return (
        <span>
            {(props.riskLevel.toLocaleLowerCase() ===
                'Low'.toLocaleLowerCase() && (
                <SeverityLevel text={'Low'} level={SeverityLevelEnum.LOW} />
            )) ||
                (props.riskLevel.toLocaleLowerCase() ===
                    'Medium'.toLocaleLowerCase() && (
                    <SeverityLevel
                        text={'Medium'}
                        level={SeverityLevelEnum.MEDIUM}
                    />
                )) ||
                (props.riskLevel.toLocaleLowerCase() ===
                    'High'.toLocaleLowerCase() && (
                    <SeverityLevel
                        text={'High'}
                        level={SeverityLevelEnum.HIGH}
                    />
                ))}
        </span>
    );
}

export default RiskLevel;
